<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.5 15a3.45 3.45 0 00-2.5 1.11L9 12.6a3.81 3.81 0 000-.6 3.81 3.81 0 00-.06-.6l7-3.51A3.45 3.45 0 0018.5 9 3.5 3.5 0 1015 5.5a3.81 3.81 0 00.06.6L8 9.61A3.45 3.45 0 005.5 8.5a3.5 3.5 0 000 7A3.45 3.45 0 008 14.39l7 3.51a3.81 3.81 0 00-.06.6A3.5 3.5 0 1018.5 15z"/></svg>